import { maxDurability, type ItemStack } from "../world/items";

/**
 * Shared small bar used under hotbar and inventory icons.
 *
 * Tools own per-instance durability, so the UI asks the item registry whether
 * a stack has a maximum and how much is left. Non-tools hide the bar entirely.
 */

export interface DurabilityView {
  readonly bar: HTMLElement;
  readonly fill: HTMLElement;
}

export function createDurabilityBar(): DurabilityView {
  const bar = document.createElement("div");
  bar.className = "durability";
  bar.style.display = "none";

  const fill = document.createElement("div");
  fill.className = "durability-fill";
  bar.appendChild(fill);

  return { bar, fill };
}

export function updateDurability(view: DurabilityView, stack: ItemStack | null): void {
  const max = stack ? maxDurability(stack.id) : 0;
  if (!stack || max <= 0) {
    view.bar.style.display = "none";
    return;
  }

  const uses = Math.max(0, Math.min(max, stack.durability ?? max));
  const fraction = uses / max;
  view.bar.style.display = "block";
  view.fill.style.width = `${Math.round(fraction * 100)}%`;
  view.fill.style.background =
    fraction > 0.5 ? "#57c957" : fraction > 0.25 ? "#d8c542" : "#e05252";
}
